<template>
  <div class="Insurance">
    <BannerImg :img-url="$StaticFileUrl + '/mp/BannerImage/solution_banner_2.jpg'">
      <div class="title wow fadeInDown" data-wow-duration="1s">保险行业增长解决方案</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">保险行业虽发展潜力巨大，但粗放式运营无法支撑保费增长，数字化转<br>型成为保险企业的共同选择</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即咨询</div>
        <div class="btn-red-linear wow flipInX" data-wow-duration="1s" style="margin-top: 100px">免费试用</div>
      </div>
    </BannerImg>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
import BannerImg from '@/components/BannerImg'
export default {
  name: 'Insurance',
  components: {
    BannerImg,
  },
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
